import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import NotificationProvider from 'shared/context/Notifications'
import CustomSnackbar from 'shared/components/CustomSnackbar'
import NotFound from 'shared/components/404'

import ResetPassword from './views/ResetPassword'
import OrderReflink from './views/OrderReflink'
import Homepage from './views/Homepage'
import { en, pl, de } from './locales'
import OrderReflinkComplete from './views/OrderReflinkComplete'
import UnauthorizedLayout from './components/Layout'
import CooperationReflink from './views/CooperationReflink'
import CooperationFormCompleted from './views/CooperationFormCompleted'
import SessionEnd from './views/SessionEnd'
import ClientCartReflink from './views/ClientCartReflink'
import Register from './views/Register'
import PrivacyPolicy from './views/PrivacyPolicy'
import Cookies from './views/Cookies'
import TermsOfUse from './views/TermsOfUse'
import RegisterCompleted from './views/RegisterCompleted'
import PaymentCompleted from './views/PaymentCompleted'

export default function Unauthorized() {
   const { i18n } = useTranslation(['UNAUTHORIZED', 'GLOBALS'])
   i18n.addResourceBundle('pl-PL', 'UNAUTHORIZED', pl)
   i18n.addResourceBundle('en-EN', 'UNAUTHORIZED', en)
   i18n.addResourceBundle('de-DE', 'UNAUTHORIZED', de)

   return (
      <NotificationProvider>
         <Routes>
            <Route path="/" element={<UnauthorizedLayout />}>
               <Route index element={<Homepage />} />
               <Route path="reset-password" element={<ResetPassword />} />
               <Route path="privacy-policy" element={<PrivacyPolicy />} />
               <Route path="cookies" element={<Cookies />} />
               <Route path="terms-of-use" element={<TermsOfUse />} />
               <Route path="register" element={<Register />} />
               <Route path="register-completed" element={<RegisterCompleted />} />
               {/* <Route path="demo-application" element={<DemoRegister />} /> */}
               <Route path="session-end" element={<SessionEnd />} />
               {/* <Route path="demo-register-completed" element={<DemoRegisterCompleted />} /> */}
               <Route path="payment-completed" element={<PaymentCompleted />} />
               <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="client-cart-reflink" element={<ClientCartReflink />} />
            <Route path="cooperation-form" element={<CooperationReflink />} />
            <Route path="cooperation-form/*" element={<CooperationReflink />} />
            <Route path="cooperation-form-completed" element={<CooperationFormCompleted />} />
            <Route path="order-reflink" element={<OrderReflink />} />
            <Route path="order-reflink-complete" element={<OrderReflinkComplete />} />
         </Routes>
         <CustomSnackbar />
      </NotificationProvider>
   )
}
